import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();
  const { nl } = useLang();

  return (
    <article className="blog-card">
      <div className="blog-image">
        <img 
          src={blog.image || 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop'} 
          alt={(nl && blog.title_nl) || blog.title} 
        />
      </div>
      <div className="blog-content">
        <div className="blog-meta">
          <span className="blog-category">{(nl && blog.category_nl) || blog.category || 'Technology'}</span>
          <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
          <span>{blog.readTime || (nl ? '5 min lezen' : '5 min read')}</span>
        </div>
        <h3 className="blog-title" style={{ width: '100%', flex: '1', marginTop: '10px' }}>{(nl && blog.title_nl) || blog.title}</h3>
        <div className="blog-footer">
          <span className="blog-author">{nl ? 'Door' : 'By'} {blog.author || 'Admin'}</span>
          <a 
            href={`/blog-post/${blog.slug}`} 
            className="read-more" 
            onClick={(e) => { 
              e.preventDefault(); 
              navigate(`/blog-post/${blog.slug}`); 
            }}
          >
            {nl ? 'Lees meer' : 'Read More'} <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
